import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { ChartConstructorType } from "highcharts-angular";
import { GraphUtils } from "../../../analytics/graphs/utils.service";

@Component({
    selector: 'reporting-mood-distribution',
    templateUrl: './reporting-mood-distribution.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportingMoodDistributionComponent implements OnChanges {

    protected chartConstructor: ChartConstructorType = 'chart';
    protected chartOptions: Highcharts.Options;

    @Input() chartData: any;

    constructor(
        private graphUtils: GraphUtils,
    ) {
    }

    ngOnChanges() {
        if(this.chartData) {
            this.chartOptions = this.reportingMoodDistributionConfig(this.chartData); // Required
        }
    }

    reportingMoodDistributionConfig (chartData): Highcharts.Options {
        return {
            chart: {
                type: 'column',
                height: 250,
                backgroundColor: this.graphUtils.graphBackgroundColor,
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'category',
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Moods'
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                pointFormat: '<b>{point.y} moods</b>'
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            series: [{
                name: 'Population',
                data: [
                    {
                        name: 'Positive',
                        y: chartData.positive,
                        prop: chartData.positiveProp,
                        color: '#1c7d1c'
                    },
                    {
                        name: 'Neutral',
                        y: chartData.neutral,
                        prop: chartData.neutralProp,
                        color: 'lightgrey'
                    },
                    {
                        name: 'Negative',
                        y: chartData.negative,
                        prop: chartData.negativeProp,
                        color: '#9a1010'
                    }
                ],
                dataLabels: {
                    enabled: true,
                    format: '{point.prop}%',
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            }]
        }
    }

}
